import React, { Component } from 'react'

const Button = ( props ) => (
    <a className={`button standard${props.className ? ` ${props.className}` : '' }${props.hoverwhite ? ` hoverwhite` : '' }`} href={ props.href } onClick= { props.onClick ? props.onClick : null } target={ props.target ? props.target : '_self'} style={ props.style }>
        { props.text }
        <svg width="21px" height="10px" viewBox="0 0 21 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="3-GCY-home-r2-@2x" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-343.000000, -6950.000000)" strokeLinecap="square">
                <g id="success-stories" transform="translate(0.000000, 6345.000000)" stroke="#FFFFFF" strokeWidth="1.5">
                    <g id="button---explore-destinations" transform="translate(194.000000, 604.000000)">
                        <g id="arrow" transform="translate(150.000000, 2.000000)">
                            <polyline id="Line-2" points="15 0 19 4 15 8"></polyline>
                            <path d="M0,4 L18,4" id="Line-3"></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    </a>
)

export default Button



// WEBPACK FOOTER //
// ./src/components/Button/index.js